export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-problem-2.94c0922b.png";